// Central config for small pieces of user-editable branding we don't
// yet expose through the admin UI. Change here to update everywhere.
export const BUY_ME_A_COFFEE_URL = "https://buymeacoffee.com/lastjonny";
